import { urlWrapper } from './utils/url/urlWrapper';

export const links = Object.freeze({
  BOOK_DELIVERY: '/webshop/getAddressesForDelivery.do',
  COUPONS: '/webshop/coupons.go',
  CHANGE_DELIVERY: '/webshop/displaySlotDetails.do',
  CHECKOUT: '/webshop/startCheckout.do',
  DISPLAY_BASKET: '/webshop/displaySmartBasket.do',
  DISPLAY_LOGGED_OUT_BASKET: '/webshop/displayLoggedOutSmartBasket.do',
  EDIT_ORDER: '/webshop/editOrder.do',
  EDIT_ORDER_DELIVERY: '/webshop/editOrderDelivery.do',
  EXPORT_FAVOURITES: '/webshop/exportFavourites.go',
  IMPORT_FAVOURITES: '/webshop/selectStoreForImport.go',
  REBOOK_ORDER: '/webshop/getAddressesForRebook.do',
  REPEAT_ORDER: '/webshop/placeRepeatOrder.do',
  SEASONAL_DELIVERY: '/webshop/getSeasonalSlots.do',
  SHOW_FAVOURITES: '/webshop/displayPrevPurchases.do',
  VIEW_ORDER: '/webshop/displayOrder.do',
  VIEW_ORDERS: '/webshop/displayAllOrders.do',
});

export const linksWithQuery = Object.freeze({
  BOOK_DELIVERY: urlWrapper(links.BOOK_DELIVERY, ['fromBookSlotPrompt']),
  COUPONS: urlWrapper(links.COUPONS, ['src']),
  EDIT_ORDER: urlWrapper(links.EDIT_ORDER, ['orderNo', 'merge', { userCsrfToken: '_csrf' }]),
  EDIT_ORDER_DELIVERY: urlWrapper(links.EDIT_ORDER_DELIVERY, ['orderNo']),
  REBOOK_ORDER: urlWrapper(links.REBOOK_ORDER, [{ orderNo: 'rebookOrderNo' }]),
  REPEAT_ORDER: urlWrapper(links.REPEAT_ORDER, [{ orderNo: 'repeatOrderNo' }]),
  SEASONAL_DELIVERY: urlWrapper(links.SEASONAL_DELIVERY, ['checkout']),
  SHOW_FAVOURITES: urlWrapper(links.SHOW_FAVOURITES, ['from']),
  VIEW_ORDER: urlWrapper(links.VIEW_ORDER, ['orderNo']),
});
